/**
 * Voice Reactions — pre-recorded clips triggered by game events.
 * Clips live in public/voice/ so they can be added without a rebuild.
 * Falls back silently if a file is missing.
 */

const BASE = `${process.env.PUBLIC_URL || ""}/voice`;

const CLIPS = {
  six:       `${BASE}/voice_six.mp3`,
  bad_roll:  `${BASE}/voice_bad_roll.mp3`,
  eaten:     `${BASE}/voice_eaten.mp3`,
  eat:       `${BASE}/voice_eat.mp3`,
  win:       `${BASE}/voice_win.mp3`,
  legendary: `${BASE}/voice_legendary.mp3`,
};

let enabled = true;
let current = null; // currently playing Audio element

export function setVoiceReactionsEnabled(val) {
  enabled = Boolean(val);
  if (!enabled && current) {
    current.pause();
    current.currentTime = 0;
  }
}

export function isVoiceReactionsEnabled() {
  return enabled;
}

export function playVoice(name, delayMs = 0) {
  if (!enabled || typeof window === "undefined") return;
  const src = CLIPS[name];
  if (!src) return;

  const fire = () => {
    try {
      // Stop any currently playing voice
      if (current) {
        current.pause();
        current.currentTime = 0;
      }
      const audio = new Audio(src);
      audio.volume = 0.88;
      current = audio;
      audio.play().catch(() => {}); // silent if file missing
    } catch (_) {}
  };

  if (delayMs > 0) {
    setTimeout(fire, delayMs);
  } else {
    fire();
  }
}
